import React, { forwardRef, useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./courseSlider.css";

// import Courses1 from "../../images/syllabus/data-analytics.png";
import Courses2 from "../../images/Courses(2).png";
import Courses3 from "../../images/Courses(3).png";
import Courses4 from "../../images/Courses(4).png";
import selesforce from "../../images/course/selesfoce.png";
import generativeAI from "../../images/course/artificial-intelligence.png";
import dataAnalytics from "../../images/course/DATA ANALYTICS.png";
import linux from "../../images/course/linux basic and command.png";
import python from "../../images/course/python.jpg";
// import dm from "../../images/course/Social Media Marketing.png";

import CurriculumForm from "./CurriculumForm";

const coursesData =  [
    {
      id: 1,
      image: Courses2,
      title: "DevOps Cloud Computing & AI",
      duration: "45 days (6 Weeks)",
      details:
        "Linux, AWS, Azure, Jenkins, Ansible and Terraform, Docker, Kubernetes",
    },
    {
      id: 2,
      image: Courses3,
      title: "Data Science with ML & AI",
      duration: "45 days (6 Weeks)",
      details:
        "Python, Databases, Machine Learning, Deep Learning, Computer Vision, NLP",
    },
    {
      id: 3,
      image: Courses4,
      title: "Full Stack Web Development & AI",
      duration: "45 days (6 Weeks)",
      details: "HTML, CSS, JavaScript, ReactJS, NodeJS, ExpressJS, MongoDB",
    },
    {
      id: 4,
      image: dataAnalytics,
      title: "Data Analytics",
      duration: "45 days (6 Weeks)",
      details:
        "Excel, SQL, Data Visualization, Power BI, Tableau, Dashboards, ETL",
    },
    {
      id: 5,
      image: linux, // Replace with actual image
      title: "Linux",
      duration: "14 days",
      details: "Linux fundamentals, Shell scripting, System administration, Security",
    },
    {
      id: 6,
      image: python, // Replace with actual image
      title: "Python",
      duration: "14 days",
      details:
        "Python basics, OOPs, File handling",
    },
    {
      id: 7,
      image: Courses4, // Replace with actual image
      title: "Frontend Development",
      duration: "14 days",
      details:
        "HTML, CSS, JavaScript, Responsive Design, React.js, UI/UX best practices",
    },
    {
      id: 8,
      image: generativeAI, // Replace with actual image
      title: "Generative AI",
      duration: "6 Weeks",
      details:
        "AI fundamentals, Neural networks, Large Language Models (LLMs), GANs",
    },
    {
      id: 9,
      image: selesforce
      , // Replace with actual image
      title: "Salesforce & DevOps",
      duration: "6 Weeks",
      details:
        "Salesforce fundamentals, Apex programming, DevOps practices, CI/CD pipelines",
    },
  ];
  

const Courses = forwardRef((props, ref) => {
  const [curriculum, setCurriculum] = useState({
    isOpen: false,
    courseId: null,
  });

  // Store the Swiper instance in a ref
  const swiperRef = useRef(null);

  const openCurriculum = (courseId) => {
    setCurriculum({ isOpen: true, courseId });
  };

  // Handler functions for mouse events
  const handleMouseEnter = () => {
    if (swiperRef.current && swiperRef.current.autoplay) {
      swiperRef.current.autoplay.stop();
    }
  };

  const handleMouseLeave = () => {
    if (swiperRef.current && swiperRef.current.autoplay) {
      swiperRef.current.autoplay.start();
    }
  };

  return (
    <section ref={ref} className="CoursesSec" id="CourseID">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h2 className="Headings text-center">
              Our Summer Internship Courses
            </h2>
          </div>
          <div className="col-12">
            <div
              className="swiper-container"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <div className="CoursesDiv">
                <Swiper
                autoHeight={true}
                  spaceBetween={20}
                  slidesPerView={1}
                  breakpoints={{
                    768: { slidesPerView: 2 },
                    1024: { slidesPerView: 4 },
                  }}
                  loop={true}
                //   autoplay={false}
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                  }}
                  speed={3000}
                  modules={[Autoplay]}
                  onSwiper={(swiper) => {
                    // Store swiper instance in ref
                    swiperRef.current = swiper;
                  }}
                >
                  {coursesData.map((course) => (
                    <SwiperSlide style={{ height: "100%" }} key={course.id}>
                      <div className="course-card-custom">
                        <div className="course-card-icon-custom">
                          <img src={course.image} alt="course" />
                          <div className="course-card-title-custom">
                            {course.title}
                          </div>
                        </div>
                        <div className="course-card-content-custom">
                          <ol>
                            <li>Duration - {course.duration}</li>
                            <li>{course.details}</li>
                          </ol>
                        </div>
                        <button
                          type="button"
                          onClick={() => openCurriculum(course.id)}
                          className="course-card-button-custom"
                        >
                          Download Curriculum
                        </button>
                      </div>
                      {/* <div className="icn">
                            <img src={course.image} alt="course" />
                            <div className="con">{course.title}</div>
                          </div>
                          <div className="conLI">
                            <ol>
                              <li>Duration - {course.duration}</li>
                              <li>{course.details}</li>
                            </ol>
                          </div>
                          <button
                            type="button"
                            onClick={() => openCurriculum(course.id)}
                            className="curriculumBTN"
                          >
                            Download Curriculum
                          </button> */}
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
            <button className="YellowBTN mt-4 m-auto d-flex justify-content-center">
              Enroll Now
            </button>
          </div>
        </div>
      </div>

      {curriculum.isOpen && (
        <CurriculumForm
          closeCurriculum={() =>
            setCurriculum({ isOpen: false, courseId: null })
          }
          courseId={curriculum.courseId}
        />
      )}
    </section>
  );
});

export default Courses;

// function CoursesSlider() {
//   return (
//     <div style={{width:'264px',margin:'0 auto'}} >
//     <div style={{background:'white',padding:'20px',borderRadius:'10px',width:'100%',
//         display:"flex", flexDirection:"column",justifyContent:"center",alignItems:"center"
//     }} >
//       <div style={{display:'flex',alignItems:'center',justifyContent:'center',columnGap:'10px'}} >
//         {/* <img src={course.image} alt="course" /> */}
//         {/* <img src={Courses1} alt="course" /> */}

//         <img src={Courses1} alt="course" style={{width:'70px',objectFit:'contain',height:'auto'}} />

//       </div>
//       <div className="conLI">
//         <ol>
//           <li style={{fontSize:'19px',color:'#ff9416',fontWeight:'700'}}>Duration - 6 months</li>

//           <li style={{fontSize:'19px',color:'#ff9416',fontWeight:'700'}}>HTML, CSS, JavaScript, ReactJS, NodeJS, ExpressJS, MongoDB</li>
//         </ol>
//       </div>
//       <button
//         type="button"
//         // onClick={() => openCurriculum(course.id)}
//         style={{background:'linear-gradient(to right, #033567 , #ff9416)',borderRadius:'12px',boxShadow:'#ffffff 0 0 0 3px, transparent 0 0 0 0',color:'#fff',border:'2px solid #ff9416',cursor:'pointer',fontSize:'16px',fontWeight:'600',padding:'7px 17px',transition:'box-shadow .2s',userSelect:'none',WebkitUserSelect:'none',touchAction:'manipulation',width:'-moz-fit-content',width:'fit-content',margin:'0 auto',marginTop:'auto'}}
//       >
//         Download Curriculum
//       </button>
//     </div>
//     </div>
//   );
// }
// export default CoursesSlider;
